import React from "react";

function Loader() {
  return (
    <div className="loader">
      <p>Loading...</p>
    </div>
  );
}

export default Loader;
